import { css } from 'styled-components';
import { variant as styledSystemVariant } from 'styled-system';
import { muiBankTheme } from '../../tools/theme';
import whisper from '../../whisper';
export const buttonVariants = styledSystemVariant({
    variants: muiBankTheme.buttons,
});
export const getIconMargin = (theme, iconPosition) => {
    const marginPosition = iconPosition !== 'right' ? 'marginRight' : 'marginLeft';
    return { [marginPosition]: theme.space.xs };
};
/**
 * Pass in the theme to generate size-specific styles
 * Returns css styles as javascript objects
 */
export const buildStylesBySize = ({ space, fontSizes, }) => ({
    sm: {
        height: '32px',
        // TODO - update, when possible, padding size of '12px' to consume value
        // from theme instead of hardcoding value
        padding: `${space.xs} 12px`,
        fontSize: fontSizes.sm,
        lineHeight: '16px',
    },
    md: {
        height: '44px',
        padding: `0 ${space.md}`,
        fontSize: fontSizes.md,
        lineHeight: '24px',
    },
});
/**
 * Returns size specific styles as a string literal,
 * usable in the `css` styled component function
 * e.g. `styled.button`'`${stylesBySize.sm}`'
 */
export const stylesBySize = {
    sm: css(({ theme }) => buildStylesBySize(theme).sm),
    md: css(({ theme }) => buildStylesBySize(theme).md),
};
/**
 * If button is inside of a ButtonGroup, uses the ButtonGroup-level
 * size prop over the button-level size prop.
 * If neither are specified, defaults to 'md'
 */
export const deriveSize = (buttonGroupContext, buttonSizeProp = 'md') => buttonGroupContext.buttonSize ? buttonGroupContext.buttonSize : buttonSizeProp;
/**
 * Theme provides the color hex value, but Icon needs the color name
 * So we find the color name that maps to the hex value
 */
export const mapHexToColorName = (color) => {
    const colorName = Object.entries(muiBankTheme.colors).filter(x => x[1] === color)[0][0];
    if (!colorName) {
        whisper.error({
            message: `Unable to map color hex to a named color from theme`,
        });
    }
    return colorName;
};
//# sourceMappingURL=utils.js.map